import React from 'react';

const defaultPublic = (_theme, _this) => {

    return {
        //表单
        formBox: {
            width: "18.75rem",
            //minHeight: "4.375rem",
            position: "relative",//如果注掉这个，报错的宽度将要计算
            fontFamily: "Microsoft YaHei"
        },


        /**
         *  大盒子边框
         */
        formCont_default: {
            display: "flex",
            width: "100%",
            minHeight: "2rem",
            WebkitAppearance: "none",
            boxSizing: "border-box",
        },
        //默认
        formCont_box: {
            display: "flex",
            width: "100%",
            minHeight: "2rem",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            border: _theme.publicForm.border ? `${_theme.publicForm.borderColor || '#E1E1E1'} solid 0.08rem` : "",
            boxSizing: "border-box",
        },
        //点击
        formContFocus_box: {
            display: "flex",
            width: "100%",
            minHeight: "2rem",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            border: _theme.publicForm.border ? `${_theme.publicForm.focusBorderColor || '#4AA5FF'} solid 0.08rem` : "",
            boxShadow: _theme.publicForm.boxShadow ? `0 0 0.25rem 0 ${_theme.publicForm.boxShadowVal || '#95c8fa'}` : "",
            boxSizing: "border-box",
        },
        //禁用
        formContDiabled_box: {
            display: "flex",
            width: "100%",
            minHeight: "2rem",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            border: _theme.publicForm.disBorder ? `${_theme.publicForm.disBorderColor || '#E1E1E1'} dashed 0.08rem` : "",
            boxSizing: "border-box",
        },


        /**
         * 表单文字描述
         */
        formText: {
            width: "8.75rem",
            minHeight: "2rem",
            display: "flex",
            alignItems: "center",
            // justifyContent: "space-between",
            // fontSize: "1.125rem",
            position: "relative",
            cursor: "default",
            justifyContent: _this.props.textAlign ?
                _this.props.textAlign == 'right' ? "flex-end" : "flex-start"
                : _theme.publicForm.textAlign == 'right' ? "flex-end" : "flex-start",
            fontSize: `${_theme.publicForm.textFontSize || ""}`,
        },
        formTextSpan: {
            // marginLeft: "0.8rem",
            // marginRight: "0.8rem",
            color: `${_theme.publicForm.textColor || '#000'} dashed 0.08rem`,
        },
        formTextSpanDis: {
            color: `${_theme.publicForm.disTextColor || '#E1E1E1'} dashed 0.08rem`,
            // marginLeft: "0.8rem"
        },
        //校验 * 号
        formRequired: {
            color: 'red',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: '1.25rem',
        },
        //分割线
        formTextSpanLine: {
            background: "#dbdbdb",
            width: "0.08rem",
            display: _theme.publicForm.dividingLine ? "block" : "none",
            height: "1.2rem",
            margin: "auto",
        },


        /**
         * input输入框
         */
        formVInput_delfault: {
            width: "10rem",
            // height: "100%",
            // position: "relative",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            border: _theme.publicForm.valueBorder ? `${_theme.publicForm.valueBorderColor || '#4AA5FF'} solid 0.08rem` : "",
            boxSizing: "border-box",
            fontSize: `${_theme.publicForm.valueFontSize || ""}`,
        },
        formVInputFocus_delfault: {
            width: "10rem",
            // height: "100%",
            // position: "relative",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            border: _theme.publicForm.valueBorder ? `${_theme.publicForm.valueFocusBorderColor || '#4AA5FF'} solid 0.08rem` : "",
            boxSizing: "border-box",
            fontSize: `${_theme.publicForm.valueFontSize || ""}`,
        },
        formVInputError_delfault: {
            width: "10rem",
            // height: "100%",
            // position: "relative",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            border: _theme.publicForm.errorColor ? `${_theme.publicForm.errorColor || '#e4393c'} solid 0.08rem` : "",
            boxSizing: "border-box",
            fontSize: `${_theme.publicForm.valueFontSize || ""}`,
        },
        formVInputDisabled_delfault: {
            width: "10rem",
            // height: "100%",
            // position: "relative",
            WebkitAppearance: "none",
            borderRadius: "0.1875rem",
            transition: "all 500ms",
            background: "#f4f4f4",
            border: _theme.publicForm.valueBorder ? `${_theme.publicForm.valueBorderColor || '#4AA5FF'} solid 0.08rem` : "",
            boxSizing: "border-box",
            fontSize: `${_theme.publicForm.valueFontSize || ""}`,
            zIndex: "-2",
        },
        formVInput_box: {
            width: "10rem",
            fontSize: `${_theme.publicForm.valueFontSize || ""}`,
            // height: "100%",
            // position: "relative",
        },


        /*
         * 输入框提示语
         */
        inputHintText: {
            position: "absolute",
            color: `${_theme.publicForm.hintColor || '#ccc'}`,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: _this.props.textAlign == "center" ? "center" : "flex-start",
            zIndex: "-1",
            paddingLeft: "0.625rem",
            fontSize: `${_theme.publicForm.hintFontSize || ""}`,
            boxSizing: "border-box",
        },


        /*
         * 报错展示
         */
        errorBox_delfault: {
            display: "flex",
            alignItems: "center",
            width: "100%",
            marginTop: '0.375rem',
            borderRadius: "0.1rem",
            position: "absolute",
            boxSizing: "border-box",
            right: "0",
        },
        errorBox_box: {
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "1.375rem",
            background: "#FFEBEB",
            border: "#FBD2CD solid 0.08rem",
            marginTop: '0.2rem',
            borderRadius: "0.1rem",
            position: "absolute",
            boxSizing: "border-box",
            right: "0",
        },
        errorText: {
            display: "flex",
            margin: "0",
            padding: "0",
            fontSize: "0.75rem",
            color: `${_theme.publicForm.errorColor || "#e4393c"}`,
            marginLeft: '0.375rem',
        },
    }
};

export {
    defaultPublic,
};
